import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import Typography from '@mui/material/Typography';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckCircle';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';

import 'moment/locale/es';
import { Box } from '@mui/material';
import dayjs from 'dayjs';

export default function LineLive({ data }) {
  return (
    <Timeline>
      {data.map((item, index) => (
        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: 'auto 0' }}
            align="right"
            variant="body2"
            color="text.secondary"
          >
            <Typography fontSize={18} sx={{ lineHeight: 0, fontWeight: 'Bold' }} component="span">
              {item.nameActivity}
            </Typography>
            <Typography fontSize={15} sx={{ textTransform: 'lowercase' }}>{item.commntes}</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineConnector />
            <TimelineDot color={index === (data.length - 1) ? "success" : "primary"}>
              {index === (data.length - 1) ? <PlaylistAddCheckCircleIcon sx={{ p: 1, fontSize: 45 }} /> : <PlaylistAddCircleIcon />}
            </TimelineDot>
            {index !== (data.length - 1) && <TimelineConnector />}
          </TimelineSeparator>
          <TimelineContent sx={{ py: '12px', px: 2 }}>
            <Typography fontSize={12} sx={{ fontWeight: '300', color: '#000', textTransform: 'capitalize' }}>{item.userName} {item.lastUserName} / {item.userRol}</Typography>
            <Box sx={{ mb: 0, mt: 0 }}>
              <Typography sx={{ fontSize: 15, color: '#000000 !importamt' }} >Realiazdo el: <strong>{dayjs(item.activityUserDate.substring(0, 10)).format('DD-MM-YYYY')}</strong> </Typography>
            </Box>
            <Box sx={{ mb: 0, mt: 0 }}>
              <Typography sx={{ fontSize: 12 }} >Registrado el: <strong>{dayjs(item.trazaDate.substring(0, 10)).format('DD-MM-YYYY')}</strong></Typography>
            </Box>
          </TimelineContent>
        </TimelineItem>
      ))}
    </Timeline>
  );
}